<template>
  <CRow>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="loading">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCard style="margin-top: 20px" v-if="!loading">
      <CCardHeader>
        <h5>HTML Game Form</h5>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm="6">
            <label>Title</label>
            <CInput disabled type="text" placeholder="title" v-model="title" />
          </CCol>
          <CCol sm="6">
            <label>Enter the Description</label>
            <CInput
              disabled
              type="text"
              placeholder="Description"
              v-model="description"
            />
          </CCol>

          <CCol sm="6">
            <label>platform</label>
            <CInput
              disabled
              type="text"
              placeholder="platform"
              v-model="platform"
            />
          </CCol>
          <CCol sm="6">
            <label>Wallet Address</label>
            <CInput
              disabled
              type="text"
              placeholder="walletAddress"
              v-model="walletAddress"
            />
          </CCol>
          <CCol sm="6">
            <label>Thumbnail</label>
            <CInput
              disabled
              type="text"
              placeholder="Thumbnail Url"
              v-model="thumbnail"
            />
            <div class="text-center">
              <CButton color="success" variant="outline" size="sm">
                <a :href="thumbnail" class="play-button" target="blank">
                  View
                </a>
              </CButton>
            </div>
          </CCol>
          <CCol sm="6">
            <label>CoverImage URL</label>
            <CInput
              disabled
              type="text"
              placeholder="CoverImage URL"
              v-model="coverImage"
            />
            <div class="text-center">
              <CButton color="success" variant="outline" size="sm">
                <a :href="coverImage" class="play-button" target="blank">
                  View
                </a>
              </CButton>
            </div>
          </CCol>

          <CCol sm="6">
            <label>Game URL</label>
            <CInput disabled type="text" placeholder="Game URL" v-model="url" />
          </CCol>
          <CCol sm="3">
            <CButton
              class="mx-3 mt-4"
              color="success"
              variant="outline"
              size="sm"
            >
              <a :href="url" class="play-button" target="blank"> Play </a>
            </CButton>
          </CCol>
          <CCol sm="12">
            <p>Add Game Rules</p>
            <div class="form-group" v-for="(input, k) in this.rules" :key="k">
              <CRow>
                <CCol sm="6">
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    placeholder="Rule...."
                    v-model.number="rules[k]"
                  />
                </CCol>
              </CRow>
            </div>
          </CCol>
          <CCol sm="12">
            <p>Variable Pay Rules</p>
            <div
              class="form-group"
              v-for="(input, k) in this.variablePayRules"
              :key="k"
            >
              <CRow>
                <CCol sm="6">
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    placeholder="Tournament rules...."
                    v-model.number="variablePayRules[k]"
                  />
                </CCol>
              </CRow>
            </div>
          </CCol>
          <CCol sm="12">
            <CRow>
              <CCol sm="4">
                <span style="font-size: 14px; font-weight: bold"
                  >FixedPayout</span
                >

                <input
                  disabled
                  v-model="isFixedPayout"
                  type="checkbox"
                  value="isFixedPayout"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
              <CCol sm="4">
                <span style="font-size: 14px; font-weight: bold"
                  >Nft Utility Enable</span
                >
                <input
                  disabled
                  v-model="isNftUtilEnabled"
                  type="checkbox"
                  value="isNftUtilEnabled"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="12">
            <h3>Add NFT</h3>

            <CRow v-for="(nft, i) in this.nfts" :key="i">
              <CCol sm="4">
                <label>NFT Contract Address</label>
                <CInput
                  disabled
                  type="text"
                  v-model="nft.contractAddress"
                  placeholder="Contract Address"
                />
              </CCol>
              <CCol sm="4">
                <label>Standard</label>
                <CInput
                  disabled
                  v-model="nft.standard"
                  type="text"
                  placeholder="NFT Standard"
                />
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="12">
            <h3>Choose a Platform</h3>
            <CRow class="mt-3">
              <CCol sm="4">
                <span style="font-size: 14px; font-weight: bold">Android</span>
                <input
                  disabled
                  v-model="isAndroid"
                  type="checkbox"
                  value="isAndroid"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
              <CCol sm="4">
                <span style="font-size: 14px; font-weight: bold">Web</span>
                <input
                  disabled
                  v-model="isWeb"
                  type="checkbox"
                  value="isWeb"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
              <CCol sm="4">
                <span style="font-size: 14px; font-weight: bold">IOS</span>
                <input
                  disabled
                  v-model="isIos"
                  type="checkbox"
                  value="isIos"
                  style="float: right; width: 113px; height: 22px"
                />
                <br />
                <br />
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="12">
            <h3>Tokens</h3>
            <div class="form-group" v-for="(input, k) in this.tokens" :key="k">
              <CRow>
                <CCol sm="6">
                  <label> Token name</label>
                  <CInput
                    disabled
                    type="text"
                    placeholder="platform"
                    v-model="input.name"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Token thumbnail</label>
                  <CInput
                    disabled
                    type="text"
                    placeholder="Token thumbnail"
                    v-model="input.icon"
                  />
                  <div class="text-center">
                    <CButton color="success" variant="outline" size="sm">
                      <a :href="input.icon" class="play-button" target="blank">
                        View
                      </a>
                    </CButton>
                  </div>
                </CCol>
                <CCol sm="6">
                  <label>Token ContractAddress</label>
                  <CInput
                    disabled
                    type="text"
                    placeholder="Token ContractAddress"
                    v-model="input.contractAddress"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Payout Maximum Percentage</label>
                  <CInput
                    disabled
                    type="number"
                    placeholder="Enter the Payout Maximum Percentage"
                    v-model.number="input.varPayMaxPer"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Payout Minimum Percentage</label>
                  <CInput
                    disabled
                    type="number"
                    placeholder="Enter the Payout Minimum Percentage"
                    v-model.number="input.varPayMinPer"
                  />
                </CCol>
                <CCol sm="6">
                  <label>Token Minimum Variable Fee</label>
                  <CInput
                    disabled
                    type="number"
                    placeholder="Minimum Variable Fee"
                    v-model.number="input.minVarFee"
                  />
                </CCol>
              </CRow>
            </div>
          </CCol>
          <CCol sm="12">
            <h2>Categories</h2>
          </CCol>

          <CCol
            sm="2"
            class="mb-2 d-flex align-items-center"
            v-for="(input, k) in this.categories"
            :key="k"
            v-if="input.name != 'All'"
          >
            <span style="font-size: 14px; font-weight: bold">{{
              input.name
            }}</span>
            <input
              class="mx-3"
              v-model="selectedCategory"
              disabled
              type="radio"
              v-bind:value="input.name"
              name="gameCategory"
            />
            <br />
            <br />
          </CCol>

          <CCol sm="12" style="text-align: center !important">
            <!-- <span class="badge badge-success" v-if="approved">Approved</span> -->
            <CButton
              v-if="!approved"
              color="success"
              style="width: 20%"
              @click="Approve()"
              >Approve</CButton
            >
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CRow>
</template>

<style src="spinkit/spinkit.min.css"></style>


<script>
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  components: { VueCtkDateTimePicker },
  data() {
    return {
      loading: true,
      description: "",
      isFixedPayout: false,
      isAndroid: false,
      isWeb: false,
      title: "",
      platform: "HTML",
      thumbnail: "",
      isIos: false,
      rules: [""],
      tokenName: "",
      coverImage: "",
      walletAddress: "",
      url: "",
      tokens: {},
      variablePayRules: [""],
      categories: [],
      id: "",
      docId: null,
      approved: false,
      isNftUtilEnabled: false,
      selectedCategory: null,
      nfts: [
        {
          contractAddress: "",
          standard: "",
        },
      ],
    };
  },
  methods: {
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    changeDateUpdate() {
      this.isDateUpdate = true;
    },
    startTimeDateUpdate() {
      this.isstartTimeDateUpdate = true;
      this.startTime = "";
    },
    endTimeDateUpdate() {
      this.isEndTimeDateUpdate = true;
      this.endTime = "";
    },
    extraPayTimeDateUpdate() {
      this.isExtraPayTimeUpdate = true;
      this.extraPayTime = "";
    },
    allowFreeUpdate() {
      this.isAllowFreeUpdate = true;
      this.allowFree = [
        {
          endTime: "",
          startTime: "",
        },
      ];
    },
    async getCategories() {
      this.tableData = [];

      // console.log("firebase.auth().currentUser.getIdToken()", token);

      await db
        .collection("gameConfig")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (
              doc.data().name != "New" &&
              doc.data().name != "1 vs 1" &&
              doc.data().name != "Free"
            ) {
              let data = doc.data();
              // console.log("doc.data()", doc.data());
              data.isInclude = doc.data().name == "All" ? true : false;
              this.categories.push(data);
            }
          });
        })
        .catch((e) => console.log("errror", e));
      //   console.log("categitesss", this.categories);
    },
    getDataByID(id) {
      db.collection("gamesCategoriesV2")
        .doc(id)
        .get()
        .then((snapshot) => {
          // console.log("snapshot", snapshot);
          if (snapshot.exists) {
            this.rules = snapshot.data().rules;
            this.description = snapshot.data().description;
            this.isFixedPayout = snapshot.data().fixedPayout;
            this.isAndroid = snapshot.data().isAndroid;
            this.isWeb = snapshot.data().isWeb;
            this.title = snapshot.data().title;
            this.platform = snapshot.data().platform;
            this.thumbnail = snapshot.data().thumbnail;
            this.isIos = snapshot.data().isIos;
            this.rules = snapshot.data().rules;
            this.coverImage = snapshot.data().coverImage;
            this.walletAddress = snapshot.data().walletAddress;
            this.url = snapshot.data().url;
            this.docId = snapshot.id;
            this.approved = snapshot.data().approved;
            this.tokens = snapshot.data().tokens;
            this.isNftUtilEnabled = snapshot.data().isNftUtilEnabled;
            this.nfts = snapshot.data().nfts;
            this.variablePayRules = snapshot.data().variablePayRules;
            let categoriesFilter = [];
            categoriesFilter = snapshot.data().categories;
            categoriesFilter.map((el) => {
              if (el != "All") {
                this.selectedCategory = el;
              }
            });
          }
          this.loading = false;
          //   console.log("snapshot.data()", snapshot.data());
        })
        .catch((e) => {
          console.log("errror", e);
          this.loading = false;
        });
    },

    async Approve() {
      this.loading = true;
      // console.log("approsdcsdfsdfs", this.docId);
      const token = await firebase.auth().currentUser.getIdToken();

      const headers = {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "x-access-token": token,
        },
      };
      try {
        const response = await axios.post(
          "https://us-central1-token-geomine.cloudfunctions.net/api/approveGame",
          {
            docId: this.id,
          },
          headers
        );
        console.log("response", response);
        if (response.data.Status == true) {
          this.loading = false;
          this.showMessage("Approved Successfully", "success");
          this.$router.push({
            name: "GamesApproval",
          });
        } else {
          this.loading = false;
          this.showMessage("Error while Apporve", "warning");
        }
      } catch (error) {
        this.loading = false;
        console.log("error", error);
        this.showMessage("Error while Updating Game", "warning");
      }
    },
    addToken() {
      if (this.tokenName === "") return;
      this.tokens[this.tokenName] = {
        name: this.tokenName,
        thumbnail: "",
        contractAddress: "",
        minVarFee: 0,
        maxLimit: 0,
        isDynamic: false,
        isToken: false,
        minLimit: 0,
        minimumToClaim: 0,
        overAllLimit: 0,
        icon: "",
        minVarPay: 0,
        dailyLimit: 0,
        playCost: 0,
      };

      this.tokenName = "";
      this.$forceUpdate();
    },
    deleteToken(key) {
      this.tokens.delete(key);
      this.$forceUpdate();
    },
  },
  created() {
    this.id = this.$route.params.id;
    // console.log("this.id", this.id);
    this.getCategories();
    this.getDataByID(this.id);
  },
};
</script>

<style>
.play-button {
  color: #26994d;
  text-decoration: none;
}
.play-button:hover {
  color: #fff;
  text-decoration: none;
}
</style>